import api from '@/api'

// 登录
export function login(data) {
    return api({
        url: '/api/admin/auth/pwdLogin',
        method: 'post',
        data
    })
}

